import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useExperience } from '../../contexts/ExperienceContext';
import { improvementPriorities, resonanceOptions, resonanceResponse } from '../../data/journeys';
import { needById } from '../../data/needs';
import { Advance } from '../ui/Advance';
import { PillChoices } from '../ui/PillChoices';
import { Eyebrow, RevealText, Stage } from '../ui/Stage';

/** Reflect the problem back before showing anything that resembles a product. */
export function MirrorStage() {
  const {
    signals,
    update,
    next,
    direction
  } = useExperience();
  const reflection = improvementPriorities.find(item => item.id === signals.priority) ?? improvementPriorities[0];
  const accent = needById(reflection.need).accent;
  const [asking, setAsking] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setAsking(true), 1700);
    return () => window.clearTimeout(timer);
  }, []);
  return <Stage direction={direction} className="min-h-screen py-28 sm:py-32" labelledBy="mirror-title" data-id="element-268" data-mp="3uef54ck7xkye">
      <div className="max-w-4xl" data-id="element-269" data-mp="3qctvd02zdmsf">
        <Eyebrow accent={accent} data-id="element-270" data-mp="3qbsbq77wfrz3">You said · {reflection.label}</Eyebrow>

        <h2 id="mirror-title" className="display-tight mt-10 text-[2rem] font-light text-enamel sm:text-[3rem] lg:text-[3.9rem]" data-id="element-271" data-mp="86yvu7v5lj3b">
          <RevealText text={reflection.mirror} delay={0.2} data-id="element-272" data-mp="361bppql2ez6" />
        </h2>

        <motion.p className="mt-10 max-w-xl text-lede font-light text-mute" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.9,
        delay: 1.1
      }} data-id="element-273" data-mp="3bopf02rehnct">
          {reflection.support}
        </motion.p>

        <AnimatePresence data-id="element-274" data-mp="3gmigwjlo7v7a">
          {asking && <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: [0.16, 1, 0.3, 1]
        }} className="mt-16 border-t border-enamel/10 pt-10" data-id="element-275" data-mp="3glpfzz9e7zx2">
              <p className="text-xl font-light text-enamel sm:text-2xl" data-id="element-276" data-mp="ru5hqkdb27ms">Sound familiar?</p>
              <div className="mt-6" data-id="element-277" data-mp="wti12v4ywwkm">
                <PillChoices choices={resonanceOptions} selected={signals.resonance} accent={accent} size="lg" onSelect={choice => update({
              resonance: choice.id
            })} data-id="element-278" data-mp="wsgryw7iik5j" />
              </div>

              <AnimatePresence mode="wait" data-id="element-279" data-mp="8y6ykt27vjrw">
                {signals.resonance && <motion.div key={signals.resonance} initial={{
              opacity: 0,
              y: 14
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.55,
              ease: [0.16, 1, 0.3, 1]
            }} className="mt-10 flex flex-col gap-8" data-id="element-280" data-mp="dw8krmuxvz7l">
                    <p className="max-w-xl text-lg font-light leading-relaxed text-enamel/80" data-id="element-281" data-mp="1ya94kxznks9a">
                      {resonanceResponse[signals.resonance]}
                    </p>
                    <Advance label="Then let us reframe it" onClick={next} accent={accent} data-id="element-282" data-mp="23fmdu2hi7v30" />
                  </motion.div>}
              </AnimatePresence>
            </motion.div>}
        </AnimatePresence>
      </div>
    </Stage>;
}